import _defineProperty from "@babel/runtime/helpers/defineProperty";
import { STUDY_PLAN_METRICS_TRANSLATION_KEY } from "./constants";
export default {
  es: /*#__PURE__*/_defineProperty({}, STUDY_PLAN_METRICS_TRANSLATION_KEY, {
    STUDY_PLAN: 'Plan de estudios',
    EDIT_STUDY_PLAN: 'Editar plan de estudios',
    EDIT_STUDY_PLAN_SHORT: 'Editar plan',
    // Activity
    ACTIVITY_TITLE: 'Tu actividad en clases',
    MINUTE_COUNT: '{{minutes}} min',
    CURRENT_WEEK: 'Semana del {{startDate}} - {{endDate}}',
    ACTIVITY_EMPTY_LABEL: '¡Es hora de ir a clases! Ten un buen inicio de semana para llegar a tu objetivo semanal ⏰',
    ACTIVITY_EMPTY_3_DAYS_LABEL: '¿Todo bien? No se ha registrado ninguna actividad en clases esta semana 😢',
    ACTIVITY_IN_PROGRESS_LABEL: '¡Vas a buen ritmo! Sigue así y llegarás a tu objetivo semanal 💪',
    ACTIVITY_ALMOST_COMPLETED_LABEL: '¡Buen trabajo! Estás por llegar a tu objetivo semanal, no dejes de esforzarte 👏',
    ACTIVITY_COMPLETED_LABEL: '¡Gran esfuerzo! Has llegado tu objetivo semanal con éxito 🎉',
    ACTIVITY_EXCEDED_LABEL: '¡Wow, qué gran semana estás teniendo! Has superado tu objetivo semanal con éxito 🎉',
    WEEKLY_TARGET: 'Tu objetivo semanal es de {{minutes}} minutos',
    CHANGE_WEEKLY_TARGET: 'Si tu objetivo semanal de {{minutes}} minutos no está funcionando, puedes modificarlo ',
    CHANGE_WEEKLY_TARGET_CTA: 'aquí',
    // Progress
    PROGRESS_TITLE: 'Tu progreso esta semana',
    PROGRESS_EMPTY_LABEL: 'Aún no has registrado actividad esta semana. ¡No te quedes atrás!',
    PROGRESS_EMPTY_5_DAYS_LABEL: 'Aún no has registrado actividad esta semana. Aprovecha el fin de semana para terminar tu curso.',
    PROGRESS_IN_PROGRESS_LABEL: 'Has acumulado **{{minutes}} minuto** de actividad hasta ahora.',
    PROGRESS_IN_PROGRESS_LABEL_plural: 'Has acumulado **{{minutes}} minutos** de actividad hasta ahora.',
    PROGRESS_COMPLETED_LABEL: '¡Eres increíble! Has acumulado **{{minutes}} minuto** de actividad hasta ahora.',
    PROGRESS_COMPLETED_LABEL_plural: '¡Eres increíble! Has acumulado **{{minutes}} minutos** de actividad hasta ahora.',
    // Empty view
    EMPTY_VIEW_TITLE: 'Parece que aún no armas tu plan de estudios',
    EMPTY_VIEW_DESC: 'Queremos contribuir en tu crecimiento profesional de la mejor manera. Con un plan de estudios podrás organizarte mejor y alcanzar cada uno de tus objetivos en Crehana.',
    EMPTY_VIEW_BUTTON: 'Armar mi plan de estudios',
    // Error
    STUDY_PLAN_ERROR: 'Ocurrió un error al obtener la información de tu plan de estudios',
    STUDY_PLAN_RETRY_BUTTON_LABEL: 'Volver a intentarlo'
  })
};